import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import men_teacher from "../assets/img/men-teacher.png";
import girl_teacher from "../assets/img/girl-teacher.png";
import { URL_LIST_ALL } from "../configs/api";

const userInfoCache = {}; // cache ngoài component, toàn cục

export default function ViewUserInfo({ user_id,type=null }) {
    const { user } = useSelector((state) => state.auth);
    const [info, setInfo] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!user_id) return;

        // Nếu đã có cache thì dùng luôn
        if (userInfoCache[user_id]) {
            setInfo(userInfoCache[user_id]);
            return;
        }

        setLoading(true);
        Axios.get(`${URL_LIST_ALL}user_info/${user_id}`, user.config)
            .then((res) => {
                setLoading(false);
                if (res.data && res.data.status == "success") {
                    const userData = res.data.data;
                    userInfoCache[user_id] = userData; // cache
                    setInfo(userData);
                }
            })
            .catch((err) => {
                setLoading(false);
                console.log("Error fetching user info:", err);
            });
    }, [user_id]);

    return (
        <div className={"user-info shadow-sm " + (type ? "info-"+type : '') }>
            <div className="wrapper w-100 border shadow-sm d-flex">
                {loading && <div className="p-2">Đang tải...</div>}
                {info && !loading &&  (
                    <>
                        <span className="arrow-top fas fa-caret-up"></span>
                        <div className="avatar-group me-2">
                            <img className="avatar-img" src={info.avatar ? info.avatar + '&size=avatar' : info.sex === "Nam" ? men_teacher : girl_teacher} alt="avatar" />
                        </div>
                        <div className="u-info">
                            <div className="fullname fw-bold">{info.fullname}</div>
                            <small>{info.chucvu}</small>
                            <div><strong>{info.part}</strong></div>
                            <div><span>Công ty:</span> <strong>{info.company}</strong></div>
                            <div className="text-danger"><span className="fas fa-envelope"></span> <small>{info.email}</small></div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
